import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-minus",
  "use": "spr-minus-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"spr-minus\"><style>#spr-minus .st0{fill:#fff}#spr-minus .st1{fill:currentColor}</style><path class=\"st1\" d=\"M13 19h14v2H13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/minus.svg
// module id = 272
// module chunks = 0